// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__M12sW","singleItem":"styles_singleItem__R2_2_","absoluteBox":"styles_absoluteBox__Pdgk0","image":"styles_image__xOa2y"};